// extracted by mini-css-extract-plugin
export default {"badge":"Badges_badge__qu7lU","brown":"Badges_brown__2sNdV","gray":"Badges_gray__R5VLs"};